import { render, staticRenderFns } from "./accederTarjetaSolidaridad.vue?vue&type=template&id=5d385797&"
import script from "./accederTarjetaSolidaridad.vue?vue&type=script&lang=ts&"
export * from "./accederTarjetaSolidaridad.vue?vue&type=script&lang=ts&"
import style0 from "./accederTarjetaSolidaridad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports